

	import { Vue, Component } from "vue-property-decorator";
	import { Header } from "element-ui";
	// @Component({
	//   name: "checkDetail",
	// })
	export default{
		
		data(){
			return{
				form:{},
				tableData:{},
				tasteData:{},
				authorData:{},
				shopData:{},
				url:'https://pics1.baidu.com/feed/4610b912c8fcc3ce3ba51b6cf9155683d53f20e0.jpeg',
			};
		},
		mounted() {
				
			let paramter = {
					productEvalId:this.$route.query.id,
			};
			this.$http.get("producteval/"+this.$route.query.id,{params:paramter}).then((res: any) =>{
				
				this.tableData = res.data.data;
				this.tasteData = res.data.data.tasteVo;
				this.authorData = res.data.data.authorVo;
			});
			
		},
		created(){
			
			console.log(this.$route.query);
		},
		methods: {
			
			getAssessList(){
				console.log(this.$route.query);
			},
			onCancel(){
				// 取消
				this.$router.back();
			},
			checkError(){
				// 不通过
				// this.$router.back();
				let paramter = {
					reason:"不通过",
					result:1,
					productEvalId:this.tableData.id,
				};
				this.$http.post("producteval/approve",{params:paramter}).then((res: any) =>{
					
					let code = res.data.code;
					let msg = res.data.msg;
					if(code == 200) {
						window.location.reload();
						this.$message({
						    message: msg,
						    type: 'success'
						});
					}
				});
			},
			checkSuccess(){
				// 通过
				// this.$router.back();
				let reason = "通过";
				let result = 1;
				let productEvalId = this.tableData.id;
				
				let paramter = {
					'reason':reason,
					'result':result,
					'productEvalId':productEvalId,
				};
				this.$http.post("producteval/approve",paramter).then((res: any) =>{
					
					let code = res.data.code;
					let msg = res.data.msg;
					if(code == 200) {
						window.location.reload();
						this.$message({
						    message: msg,
						    type: 'success'
						});
					}
				});
			},

			
		},
		
	}
